import { jsxs as d, jsx as r, Fragment as s } from "react/jsx-runtime";
import { TextLink as u, Theme as C, TextLinkUnderlineStyle as f, Carousel as g } from "@nextgen-web-framework/all";
import { Fragment as m } from "react";
import { ComponentType as n } from "../../cms/registries/types/propTypes.js";
import z from "../../cms/component-transformers/article-card-transformer/article-card-transformer.js";
import V from "../../cms/component-transformers/promotion-card-transformer/promotion-card-transformer.js";
import h from "../../cms/component-transformers/resource-card-transformer/resource-card-transformer.js";
import k from "../ArticleCard/ArticleCard.js";
import _ from "../PromotionCard/PromotionCard.js";
import p from "../ResourceCard/ResourceCard.js";
import '../../assets/ContentCardCarousel.css';const B = "#ffffff", x = "#396e75", b = "#e5fdff", y = "#546223", G = "#f0fae5", O = "#a65523", R = "#fff1e8", w = "#7f3e3e", P = "#ffe2e2", v = "#62625a", W = "#f8f8e7", A = "#38539a", T = "#707070", F = "#c8f8d1", N = "#87c9c8", Y = "#5291b1", $ = "rgba(82, 145, 177, 0.1019607843)", L = "#445685", S = "#181d61", j = "rgba(24, 29, 97, 0.1019607843)", D = "#5969d6", E = "#ea999d", I = "#b6577e", K = "rgba(182, 87, 126, 0.1019607843)", U = "#7e3e80", X = "#1e247f", q = "rgba(30, 36, 127, 0.1019607843)", H = "#da7600", J = "#107f47", M = "#d91734", Q = "_html_1fxut_38", e = {
  amwayWhite: B,
  darkBlue: x,
  lightBlue: b,
  darkGreen: y,
  lightGreen: G,
  darkOrange: O,
  lightOrange: R,
  darkRed: w,
  lightRed: P,
  darkYellow: v,
  lightYellow: W,
  darkPurple: A,
  darkGrayOnWhite: T,
  dataVizColor1: F,
  dataVizColor2: N,
  dataVizColor3: Y,
  dataVizColor3Background: $,
  dataVizColor4: L,
  dataVizColor5: S,
  dataVizColor5Background: j,
  dataVizColor6: D,
  dataVizColor7: E,
  dataVizColor8: I,
  dataVizColor8Background: K,
  dataVizColor9: U,
  dataVizColor10: X,
  dataVizColor10Background: q,
  dataVizAlertOrange: H,
  dataVizSuccessGreen: J,
  dataVizWarningRed: M,
  "no-visible": "_no-visible_1fxut_34",
  html: Q,
  "content-card-carousal-container": "_content-card-carousal-container_1fxut_72",
  "content-card-carousal-header": "_content-card-carousal-header_1fxut_75",
  "content-card-carousal-title": "_content-card-carousal-title_1fxut_82"
}, ia = (o) => {
  var c;
  const l = (a) => {
    const i = /* @__PURE__ */ r(s, {});
    switch (a == null ? void 0 : a._content_type_uid) {
      case n.article_card: {
        const t = z(a);
        return /* @__PURE__ */ r(k, { ...t });
      }
      case n.promotion_card: {
        const t = V(a);
        return /* @__PURE__ */ r(_, { ...t });
      }
      case n.resource_card: {
        const t = h(a);
        return /* @__PURE__ */ r(p, { ...t });
      }
      default:
        return i;
    }
  };
  return /* @__PURE__ */ d("div", { className: `${e["content-card-carousal-container"]}`, children: [
    /* @__PURE__ */ d("div", { className: `${e["content-card-carousal-header"]}`, children: [
      /* @__PURE__ */ r("div", { className: `${e["content-card-carousal-title"]}`, children: o.title }),
      /* @__PURE__ */ r("div", { className: e["content-carousel-link"], children: /* @__PURE__ */ r(
        u,
        {
          text: o.link.text ?? "",
          href: o.link.url,
          target: o.link.target,
          theme: C.BLACK,
          underline: f.FIXED
        }
      ) })
    ] }),
    /* @__PURE__ */ r(g, { id: e["content-card-carousel"], isTileCarousel: !0, "data-testid": "content-card-carousel", "data-pod-name": "commerce", children: (c = o.contentCardCarouselData) == null ? void 0 : c.map((a) => /* @__PURE__ */ r(m, { children: l(a) }, a == null ? void 0 : a.uid)) })
  ] });
};
export {
  ia as default
};
//# sourceMappingURL=ContentCardCarousel.js.map
